export enum EnLoginState {
    Authentication = 'Authentication',
    Login = 'Login',
    Logged = 'Logged',
    Loading = 'Loading',
    LoginFail = 'LoginFail'
}
